<template>
    <div class="gp-app-desc">
        <h2 v-if="hasTitle" class="gp-app-desc__title">{{ hasTitle }}</h2>
        <div v-if="updateInfo" class="gp-app-desc__version">
            <div>版本: {{ updateInfo.version_code }}</div>
            <div>{{ updateInfo.update_time && formatTime(updateInfo.update_time) }}更新</div>
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <!--bca-disable-->
        <div
            ref="content"
            class="gp-app-desc__content"
            :style="{'-webkit-line-clamp': lineCount}"
            v-html="content"
        >
        </div>
        <!--bca-enable-->
        <div
            v-if="needExpandBtn"
            class="gp-app-desc__expand"
            @click="toggleExpand"
        >
            <span>{{ expand ? '收起' : '展开全部' }}</span>
            <img :src="expand ? dropupIcon : dropdownIcon">
        </div>
    </div>
</template>

<script>
import DropupIcon from 'public/assets/imgs/dropup.png';
import DropdownIcon from 'public/assets/imgs/dropdown.png';
import TagRightIcon from 'public/assets/imgs/desctag-right.png';
import {getQueryString} from '@/utils/url';

export default {
    props: {
        maxRows: {
            type: Number,
            default: 5,
        },
        pblogData: {
            type: Object,
            required: false,
        },
        content: {
            type: String,
            required: false,
        },
        hasTitle: {
            type: String,
            required: true,
        },
        updateInfo: {
            type: Object,
            required: false,
        },
        appTags: {
            type: Array,
            required: false,
        },
        isNewStyle: {
            type: Number,
            required: false,
        },
        operatetags: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            expand: true,
            needExpandBtn: false,
            dropupIcon: DropupIcon,
            dropdownIcon: DropdownIcon,
            tagrightIcon: TagRightIcon,
        };
    },
    computed: {
        lineCount() {
            return this.expand ? 1000 : this.maxRows;
        },
    },
    mounted() {
        this.$nextTick(() => {
            let content = this.$refs.content;
            let {lineHeight, height} = window.getComputedStyle(content);
            let lines = Math.ceil(parseFloat(height, 10) / parseFloat(lineHeight, 10));
            if (lines > this.maxRows) {
                this.expand = false;
                this.needExpandBtn = true;
            }
        });
    },
    methods: {
        toggleExpand() {
            this.expand = !this.expand;
            if (this.hasTitle === '更新信息') {
                if (this.expand) {
                    this.openActiveLog('openAll', 'update');
                }
                else {
                    this.openActiveLog('retract', 'update');
                }
            }
            else {
                if (this.expand) {
                    this.openActiveLog('openAll', 'detail');
                }
                else {
                    this.openActiveLog('retract', 'detail');
                }
            }
        },
        formatTime(time) {
            let timeStr = time.split('-');
            return timeStr[0] + '年' + timeStr[1] + '月' + timeStr[2] + '日';
        },
        openActiveLog(value, area) {
            this.$logger.click({
                value,
                ext: {
                    id: this.pblogData.package_name,
                    ext: {
                        gameId: this.pblogData.app_id,
                        gameType: this.pblogData.app_type,
                        gameName: this.pblogData.app_name,
                        sid: getQueryString('sid'),
                        srcId: getQueryString('srcid') || '',
                        area,
                    },
                    pos: '',
                },
                network: this.$wifi ? 'wifi' : '4g',
            });
        },
        jumpPage(appTag) {
            location.href = 'http://gamecenter.baidu.com/static/game/rank.html?tagName=' + appTag + '&channelid=60048';
        },
    },
};
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(app-desc) {
        padding: 0 px2rem(51);;

        @include e(title) {
            font-size: px2rem(48);
            line-height: px2rem(48);
            padding: px2rem(63) 0;
            margin: 0;
        }
        @include e(version) {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin: 0;
            font-size: px2rem(48);
        }

        @include e(content) {
            font-size: px2rem(48);
            letter-spacing: px2rem(2);
            line-height: px2rem(72);
            color: #555;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            margin-bottom: px2rem(43);
        }

        @include e(tags) {
            height: px2rem(100);
            font-size: px2rem(39);
            font-family: PingFangSC-Regular;
            scrollbar-width: none; /* firefox */
            -ms-overflow-style: none; /* IE 10+ */
            overflow-x: scroll;
            overflow-y: hidden;
            white-space: nowrap;
            &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
            }
            display: flex;
            align-items: center;
            margin-bottom: px2rem(50);
        }

        @include e(configurabletags) {
            color: #FF6600;
            font-weight: 400;
            text-align: center;
            margin-right: px2rem(24);
            border-radius: px2rem(50);
            background: #FFF1DD;
            padding: px2rem(19) px2rem(36) px2rem(20) px2rem(36);
        }

        @include e(tag) {
            background: #F0F0F0;
            margin-right: px2rem(24);
            color: #555555;
            font-weight: 400;
            border-radius: px2rem(50);
            text-align: center;
            padding: px2rem(19) px2rem(46);
        }

        @include e(tagIcon) {
            width: px2rem(21);
            height: px2rem(30);
            border-radius: 50%;
            margin: 0 auto;
            text-align: center;
        }

        @include e(expand) {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: px2rem(42);
            line-height: px2rem(42);
            color: #999;
            margin-bottom: px2rem(65);

            img {
                width: px2rem(45);
                height: px2rem(45);
                margin-left: px2rem(12);
            }
        }
    }
</style>